import React, {useLayoutEffect} from 'react'

import ModalV5 from "../../../../app/ui/modal/v5/v5"
import {Copy_Manager} from "../model/manager"
import {useForceUpdate} from "../../../gd/utils/dom-and-react/react-utils"
import {ModalCopy_CurrentStep} from "../@const"
import ErrorBoundary from "../../../error-boundary"
import UILoading from "../../../gd-ui/loading/loading"
import ModalV5_Header from "../../../../app/ui/modal/v5/header/header"
import ModalCopy_Project from "./copy-project/copy-project"
import ModalCopy_Goal from "./copy-goal/copy-goal"
import ModalCopy_Task from "./copy-task/copy-task"
import Modal_StateMessage from "../../components/state-message/state-message"
import {CopyTemplate_Manager} from "../model/copy-template-manager"
import ModalCopy_Template from "./copy-project/copy-template"
import Modal_AddMissingUsersTeams from "../../components/add-missing-users-and-teams/add-missing-users-and-teams"
import ModalCopy_Tasks from "./copy-task/copy-tasks";

type Props = {
    manager     : Copy_Manager
}

// const debug = "ModalCopy"
const debug = false

export default function ModalCopy(props:Props) {

    const manager : Copy_Manager = props.manager
    manager.reRender = useForceUpdate()

    debug && console.log(debug, 'render', props.manager.currentStep)

    useLayoutEffect(() => {
        props.manager.init()
    }, []);

    let content
    let isTemplate: boolean = false
    switch(props.manager.currentStep) {

        case ModalCopy_CurrentStep.COPY_PROJECT:
            if (props.manager instanceof CopyTemplate_Manager) {
                isTemplate = true
                content = <ModalCopy_Template manager={props.manager}/>
            } else {
                content = <ModalCopy_Project manager={props.manager}/>
            }
            break

        case ModalCopy_CurrentStep.COPY_GOAL:
            content = <ModalCopy_Goal manager={props.manager} />
            break

        case ModalCopy_CurrentStep.COPY_TASK:
            content = <ModalCopy_Task manager={props.manager} />
            break

        case ModalCopy_CurrentStep.COPY_TASKS:
            content = <ModalCopy_Tasks manager={props.manager} />
            break

        case ModalCopy_CurrentStep.CHECKING_USERS:
            content = <Modal_StateMessage message="Checking users..."/>
            break

        case ModalCopy_CurrentStep.ADD_MISSING_USERS:
            content = <Modal_AddMissingUsersTeams manager={props.manager}/>
            break

        case ModalCopy_CurrentStep.COPYING:
            content = <Modal_StateMessage message="Copying..."/>
            break

        case ModalCopy_CurrentStep.LOADING:
        default:
            return <UILoading />
    }

    const classes = Classes("modal-copy w-600 h-85p flex-column", {
        "max-h-550": !isTemplate,
        "max-h-300": isTemplate
    })

    return (
        <ModalV5 className={classes}>
            <ModalV5_Header title={props.manager.modalTitle} underline={false} />

            <ErrorBoundary>
                {content}
            </ErrorBoundary>
        </ModalV5>
    )
}
